const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    let errorDetails = null;
    try {
      const errorBody = await response.clone().json();
      errorDetails = errorBody;
    } catch {
      const errorText = await response.clone().text();
      errorDetails = errorText;
    }
    const error = new Error(`HTTP error! status: ${response.status}`);
    error.status = response.status;
    error.details = errorDetails;
    throw error;
  }

  if (response.status === 204) return null;
  return response.json();
};

export const getSavedQueries = async () => {
  const url = `${API_BASE_URL}/api/queryvault/queries`;
  return await makeRequest(url);
};

export const getSavedQuery = async (id) => {
  const url = `${API_BASE_URL}/api/queryvault/queries/${encodeURIComponent(id)}`;
  return await makeRequest(url);
};

export const createSavedQuery = async (data) => {
  const url = `${API_BASE_URL}/api/queryvault/queries`;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const updateSavedQuery = async (id, data) => {
  const url = `${API_BASE_URL}/api/queryvault/queries/${encodeURIComponent(id)}`;
  return await makeRequest(url, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

export const deleteSavedQuery = async (id) => {
  const url = `${API_BASE_URL}/api/queryvault/queries/${encodeURIComponent(id)}`;
  return await makeRequest(url, { method: 'DELETE' });
};

export const executeQuery = async ({ queryText, savedQueryId, tenantName }) => {
  const url = `${API_BASE_URL}/api/queryvault/execute`;
  const body = { tenantName };
  if (savedQueryId) {
    body.savedQueryId = savedQueryId;
  } else {
    body.queryText = queryText;
  }
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify(body),
  });
};

export const executeMultiTenantQuery = async ({ queryText, tenants, maxRowsPerTenant }) => {
  const url = `${API_BASE_URL}/api/queryvault/execute-multi`;
  const body = { queryText, tenants };
  if (maxRowsPerTenant) body.maxRowsPerTenant = maxRowsPerTenant;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify(body),
  });
};
